import axiosInstance from './AxiosInstance';
import {
    loginConfirmedAction,
    Logout,
} from '../store/actions/AuthActions';

export function login(email, password) {
    const postData = {
        email,
        password,
    };
    return axiosInstance.post(
        `/v1/auth/sign-in`,
        postData,
    );
}

export function formatError(errorResponse) {
    // Handle backend API error format
    if (errorResponse.data && errorResponse.data.message) {
        return errorResponse.data.message;
    }

    // Handle different error cases
    switch (errorResponse.status) {
        case 400:
            return errorResponse.data?.message || 'Invalid credentials';
        case 401:
            return 'Unauthorized access';
        case 404:
            return 'User not found';
        case 500:
            return 'Server error. Please try again later';
        default:
            return 'An error occurred. Please try again';
    }
}

export function saveTokenInLocalStorage(tokenDetails) {
    // Keep this for backward compatibility, but redux-persist will handle the auth state
    localStorage.setItem('userDetails', JSON.stringify(tokenDetails));
}

export function runLogoutTimer(dispatch, timer, navigate) {
    setTimeout(() => {
        //dispatch(Logout(history));
        dispatch(Logout(navigate));
    }, timer);
}

export function checkAutoLogin(dispatch, navigate) {
    const tokenDetailsString = localStorage.getItem('userDetails');
    let tokenDetails = '';
    if (!tokenDetailsString) {
        dispatch(Logout(navigate));
        return;
    }

    tokenDetails = JSON.parse(tokenDetailsString);
    let expireDate = new Date(tokenDetails.expireDate);
    let todaysDate = new Date();

    if (todaysDate > expireDate) {
        dispatch(Logout(navigate));
        return;
    }

    // With redux-persist, the auth state will be automatically restored
    // We only need to dispatch if the token is still valid
    dispatch(loginConfirmedAction(tokenDetails));

    const timer = expireDate.getTime() - todaysDate.getTime();
    runLogoutTimer(dispatch, timer, navigate);
}

export function isLogin() {
    const tokenDetailsString = localStorage.getItem('userDetails');

    if (tokenDetailsString) {
        return true;
    } else {
        return false;
    }
}
